export default __webpack_public_path__ + "48507c9f18c3e71d3d219c4b9269a9e5.jpg";